import { useLayoutEffect, useState } from 'react';

export function useScrollViewport(scrollRef) {
  const [viewport, setViewport] = useState({
    scrollTop: 0,
    viewportHeight: 0,
  });

  useLayoutEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let rafId = 0;

    const update = () => {
      rafId = 0;
      setViewport({
        scrollTop: el.scrollTop || 0,
        viewportHeight: el.clientHeight || 0,
      });
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    };

    const ro = new ResizeObserver(() => {
      update();
    });

    update();
    el.addEventListener('scroll', onScroll, { passive: true });
    ro.observe(el);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      el.removeEventListener('scroll', onScroll);
      ro.disconnect();
    };
  }, [scrollRef]);

  return viewport;
}
